// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

// Import firebase
import { propertiesModel, residentsModel } from '@/firebase/firebase-config'
import moment from 'moment';

// Import the events
import { GetUser } from '@/events/nestd-residents/GetUser'

export const UpdateResident = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        SpinnerMethods,
        GetUser

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        updated_resident_error: false,
        edit_resident_property_resident_updated: false,
        edit_resident_resident_updated: false,
        edit_resident_unit_updated: false,
        unit_needs_updating: false,
        updated_resident_complete: false,
        stripe_customer_props_set: false

    }),

    /*
    **  Watch em'
    */

    watch: {

        get_nestd_resident_complete: {

            immediate: true, // Step 2
            handler(get_nestd_resident_complete) {

                /*
                **  Update the property resident
                **  @method: @here
                */

                if (!this.updated_resident_error && get_nestd_resident_complete) this.editResidentUpdatePropertyResident();

            }

        },

        edit_resident_property_resident_updated: {

            immediate: true, // Step 5
            handler(edit_resident_property_resident_updated) {

                /*
                **  Update the property resident
                **  @method: @here
                */

                if (!this.updated_resident_error && edit_resident_property_resident_updated) this.editResidentUpdateResident();

            }

        },

        edit_resident_resident_updated: {

            immediate: true, // Step 6
            handler(edit_resident_resident_updated) {

                /*
                **  Update the resident
                **  @method: @here
                */

                if (!this.updated_resident_error && edit_resident_resident_updated) this.editResidentUpdateUnit();

            }

        },

        edit_resident_unit_updated: {

            immediate: true, // Step 7
            handler(edit_resident_unit_updated) {

                /*
                **  Update the resident
                **  @method: @here
                */

                if (!this.updated_resident_error && edit_resident_unit_updated) this.completeResidentUpdateEvent();

            }

        },

        updated_resident_error: {

            immediate: true, // Load on created
            handler(updated_resident_error) {

                /*
                **  Handle the error
                **  @method: @here
                */

                if (updated_resident_error) this.handleUpdatedResidentError();

            }

        }

    },

    /*
    **  Methods
    */

    methods: {

        updateResidentHandler: function() {

            try {

                /*
                **  If processing, return
                **  @prop: @here
                */

                if (this.edit_resident_processing) return;

                /*
                **  Set the processing prop
                **  @prop: @here
                */

                this.edit_resident_processing = true;

                /*
                **  Show the spinner
                **  @method: Mixins/Helpers/SpinnerMethods
                */

                this.showSpinner();

                /*
                **  Get the nestd residents portal user
                **  @service: @Firebase/Firestore
                */

                this.getUserHandler(this.resident.id);

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Update a Resident.',
                    errorType: 'Application',
                    section: 'Update Resident',
                    uid: '6gP9BFMC2VWnWdblCCkA',
                    error: e
                });

            }

        },

        editResidentUpdatePropertyResident: function() {

            try {

                /*
                **  Set the stripe response, if new customer
                */

                let stripe_response = this.resident.relationships.stripe.customer;
                if (this.create_stripe_customer_response) stripe_response = this.create_stripe_customer_response;

                /*
                **  Update the property resident
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('residents').doc(this.resident.id).update({
                    'attributes.contact_information.first_name': this.first_name.value,
                    'attributes.contact_information.last_name': this.last_name.value,
                    'attributes.contact_information.email': this.email.value,
                    'attributes.contact_information.phone_number': this.phone.value,
                    'attributes.unit.number': this.unit_number,
                    'relationships.unit': this.unit.value,
                    'relationships.stripe.customer': stripe_response,
                    'meta.updated_at': moment().unix()
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.edit_resident_property_resident_updated = true;

                })
                .catch(error => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.updated_resident_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Unable to Update a Property Resident Document in Firestore.',
                        errorType: 'Application',
                        section: 'Update Resident',
                        uid: 'CoOSsvQEfPmdOS3ubutI',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.updated_resident_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Update a Property Resident Document in Firestore.',
                    errorType: 'Application',
                    section: 'Update Resident',
                    uid: 'BqQW7i8pGpnHA7LpKQEo',
                    error: e
                });

            }

        },

        editResidentUpdateResident: function() {

            try {

                /*
                **  Set the stripe response, if new customer
                */

                let stripe_response = this.resident.relationships.stripe.customer;
                if (this.create_stripe_customer_response) stripe_response = this.create_stripe_customer_response;

                /*
                **  Update the resident
                **  @service: @Firebase/Firestore
                */

                residentsModel.doc(this.resident.id).update({
                    'attributes.contact_information.first_name': this.first_name.value,
                    'attributes.contact_information.last_name': this.last_name.value,
                    'attributes.contact_information.email': this.email.value,
                    'attributes.contact_information.phone_number': this.phone.value,
                    'relationships.unit': this.unit.value,
                    'relationships.stripe.customer': stripe_response,
                    'meta.updated_at': moment().unix()
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.edit_resident_resident_updated = true;

                })
                .catch(error => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.updated_resident_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Unable to Update a Resident Document in Firestore.',
                        errorType: 'Application',
                        section: 'Update Resident',
                        uid: '2i6L9wFJA2xZnqzRBsDg',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.updated_resident_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Update a Resident Document in Firestore.',
                    errorType: 'Application',
                    section: 'Update Resident',
                    uid: 'kCg1xRVHuUOaXrZjPhwE',
                    error: e
                });

            }

        },

        editResidentUpdateUnit: function() {

            try {

                /*
                **  Update the resident
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('units').doc(this.unit.value).update({
                    'attributes.available': false,
                    'attributes.resident.first_name': this.first_name.value,
                    'attributes.resident.last_name': this.last_name.value,
                    'relationships.resident': this.resident.id,
                    'meta.updated_at': moment().unix()
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.edit_resident_unit_updated = true;

                })
                .catch(error => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.updated_resident_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Unable to Update a Unit Document in Firestore.',
                        errorType: 'Application',
                        section: 'Update Resident',
                        uid: 'tvurTtgLcCRBBGX3QRZ3',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.updated_resident_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Update a Unit Document in Firestore.',
                    errorType: 'Application',
                    section: 'Update Resident',
                    uid: 'X1krdJ6UrVIh4KQaBOMC',
                    error: e
                });

            }

        },

        completeResidentUpdateEvent: function() {

            try {

                /*
                **  Reset the validation props
                **  @prop: Components/Property/Leases/EditResidentMenu
                */

                this.resetEditResidentValidationProps();

                /*
                **  Set the processing prop
                **  @prop: @here
                */

                this.edit_resident_processing = false;

                /*
                **  Reset the form props
                **  @prop: @here
                */

                this.updated_resident_error = false;
                this.edit_resident_property_resident_updated = false;
                this.edit_resident_resident_updated = false;
                this.edit_resident_unit_updated = false;
                this.unit_needs_updating = false;
                this.updated_resident_complete = false;
                this.nestd_resident_updated = false;
                this.stripe_customer_props_set = false;
                this.stripe_customer_created = false;
                this.edit_resident_processing = false;
                this.get_nestd_resident_complete = false;

                /*
                **  Close the menu
                **  @method: Components/Property/Leases/EditResidentMenu
                */

                this.closeEditResidentMenu();

                /*
                **  Hide the spinner
                **  @method: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /*
                **  Throw success message
                **  @service: SweetAlert2
                */

                this.$swal('Success!', 'Your resident has been updated.', 'success');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Complete the Resident Update Event.',
                    errorType: 'Application',
                    section: 'Update Resident',
                    uid: 'HsbL4960VKLvlZqRGhj5',
                    error: e
                });

            }

        },

        handleUpdatedResidentError: function() {

            try {

                /*
                **  Set the processing prop
                **  @prop: @here
                */

                this.edit_resident_processing = false;
    
                /*
                **  Hide the spinner
                **  @method: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /*
                **  Throw error message
                **  @service: SweetAlert2
                */

                this.$swal('Uh Oh!', 'We ran into some problems while trying to update your resident.', 'error');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Handle an Error for a Resident Update.',
                    errorType: 'Application',
                    section: 'Update Rent',
                    uid: 'mJ39IBMY0zMxYe98HPav',
                    error: e
                });

            }

        }

    }

}